module.exports = __webpack_public_path__ + "static/mailings2-4e87ba923f9b8e94db1f5a4499b5827e.png";